export const requiredField = value => (value ? undefined : 'Required field');
export const validateEmail = value =>
    value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
        ? 'Invalid email address'
        : undefined

export const validateNum = value => {
    const number = Number(value)
    if (!Number.isInteger(number) || number <= 0)
        return 'Invalid number of licenses. Must be a positive number'
    return undefined
}
